// Removed Menu import
import React, { useState } from 'react'
import { useGlobalState } from '../../../store'
import BoomerScan from '../components/BoomerScan'
import OrgScreen from '../components/OrgScreen'

const AdminScanPage = () => {
  const [license] = useGlobalState('license')
  const [currentPage, setCurrentPage] = useState('scan')
  return (
    <>
      <div className="bg-white" style={{ background: 'white' }}>
        <div className="mobile_padding min-h-screen">
          {license &&
            license.email &&
            license.email.includes('@calendarbridge.com') && (
              <>
                {/* Replaced Ant Menu with simple buttons/tabs */}
                <div className="flex border-b border-gray-200 mb-4">
                  <button
                    onClick={() => setCurrentPage('scan')}
                    className={`py-2 px-4 text-sm font-medium ${
                      currentPage === 'scan'
                        ? 'border-b-2 border-indigo-500 text-indigo-600'
                        : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    } focus:outline-none`}
                  >
                    User Admin
                  </button>
                  <button
                    onClick={() => setCurrentPage('orgs')}
                    className={`py-2 px-4 text-sm font-medium ${
                      currentPage === 'orgs'
                        ? 'border-b-2 border-indigo-500 text-indigo-600'
                        : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    } focus:outline-none`}
                  >
                    Org Admin
                  </button>
                </div>
                {currentPage == 'scan' && <BoomerScan />}
                {currentPage == 'orgs' && <OrgScreen />}
              </>
            )}
        </div>
      </div>
    </>
  )
}
export default AdminScanPage
